const isDev = process.env.NODE_ENV !== 'production';
const remote = isDev ? 'http://10.101.10.45' : location.origin;

export default {
    baseURL: `${remote}/api/ieslab-plan`,
    iesURL: `${remote}/api/ieslab-simulation`,
    userCenter: `${remote}/api`,
    isDev: !remote,
    testUrl: 'https://10.112.10.39:8081',
    projectUrl: isDev ? 'http://10.101.10.95:8089' : `${remote}/`,
};
